export const schoolTypeXNA = "xna";
export const schoolTypeUniversity = "vysoka-skola";
export const schoolTypeHighSchool = "stredni-skola";
export const schoolTypeUniversityCollectionOfExamples = "sbirky-prikladu";
